<template>
  <div>
    <!-- 景区管理 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item >位置：</el-breadcrumb-item>
      <el-breadcrumb-item>财务管理</el-breadcrumb-item>
      <el-breadcrumb-item>短信充值审核</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 卡片开始 -->
    <el-card class="conentBox">
      <el-row class="conentRow">
        <el-col class="conentColSele" :span="3">
          <el-select v-model="data.ScenicID" placeholder="全部景区" filterable clearable>
            <el-option
              v-for="item in options"
              :key="item.ScenicID"
              :label="item.Name"
              :value="item.ScenicID"
            ></el-option>
          </el-select>
          <!-- <img class="imgPosi" :src="imgXlb" alt /> -->
        </el-col>
        <el-col class="conentColSele1" :span="4">
          <!-- <el-date-picker v-model="value1" type="date" placeholder="选择日期"></el-date-picker> -->
          <el-date-picker
            v-model="value1"
            type="daterange"
            value-format="yyyy-MM-dd"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          ></el-date-picker>
          <!-- <img class="imgPosi" :src="imgXl" alt /> -->
        </el-col>
        <el-col class="conentBtn" :span="2" style="margin-left:2rem;">
          <el-button type="primary" @click="chaxun">查询</el-button>
        </el-col>
      </el-row>
      <el-table
        :data="tableData"
        :header-cell-style="tableHeaderColor"
        :cell-style="cellStyle"
        style="width: 100%"
      >
        <el-table-column label="编号" type="index"></el-table-column>
        <el-table-column prop="scenicname" label="景区名称"></el-table-column>
        <el-table-column label="收费类别">
          <template slot-scope="scope">
              <span>{{scope.row.sms_type=='1'?'订单短信':'群发短信'}}</span>
          </template>
        </el-table-column>
        <el-table-column  label="计费类型">
          <template slot-scope="scope">
              <span>{{scope.row.charge_type=='1'?'计费':'计时'}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="address" label="充值金额/天数">
          <template slot-scope="scope">
              <span>{{scope.row.charge_type=='1'?scope.row.pay:scope.row.time_days}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="jfy_amount" label="应付金额"></el-table-column>
        <el-table-column prop="createtime" label="充值时间"></el-table-column>
      
        <el-table-column prop="address" label="状态">
          <template slot-scope="scope">
            <span>{{scope.row.status=='1'?'审核通过':scope.row.status=='2'?'待审核':scope.row.status=='3'?'驳回':'待支付'}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="username" label="审核人"></el-table-column>
        <el-table-column prop="address" label="操作" width="400">
          <template slot-scope="scope">
            <el-button type="text"  v-if="scope.row.status=='1'" @click="DetailverifyFn(scope.row)">查看详情</el-button>
             <el-button type="text" v-if="scope.row.status=='2'" @click="verifyFn(scope.row)">审核</el-button>
            <el-button type="text" v-if="scope.row.status=='3'" @click="verifyFn(scope.row)">更改审核</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页开始 -->
      <div class="pagination">
        <span class="demonstration">共{{total}}条记录，</span>
        <span class="demonstration">当前显示第{{data.page}}页</span>
        <el-pagination background layout="prev, pager, next" :total="total" @current-change="currenchange"></el-pagination>
      </div>
      <!-- 分页结束 -->
    </el-card>
    <!-- 卡片结束 -->
    <el-dialog :close-on-click-modal="false"
      title="汇款支付审核"
      :visible.sync="verifyDialogVisible"
      :before-close="verifyHandleClose"
      width="32%"
      center
      class="autorDialog"
    >
      <el-divider></el-divider>
      <el-form class="editForm" label-width="120px" :model="form">
        <el-form-item label="付款户名：">
          <el-input v-model="str.remit_name" disabled />
        </el-form-item>
        <el-form-item label="付款账户：">
          <el-input v-model="str.remit_code" disabled />
        </el-form-item>
        <el-form-item label="付款时间：">
          <el-input v-model="str.remit_date"  disabled />
        </el-form-item>
        <el-form-item label="实付金额：">
          <el-input v-model="str.jfy_amount" disabled />
        </el-form-item>
        <el-form-item label="付款凭证：">
          <img style="width:25rem;height:14rem;" :src="str.remit_img" alt="">
        </el-form-item>
        <el-form-item label="审核：">
          <el-radio-group v-model="form.status">
            <el-radio :label="1">审核通过</el-radio>
            <el-radio :label="3">驳回</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="驳回原因：">
          <el-input v-model="form.remark"></el-input>
        </el-form-item>
        <el-form-item class="itemBtnS" style="margin-left:-50px" v-if="flow">
          <el-button class="btnL" @click="succesBtns">确认保存</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <!-- 信息上下线弹框结束 -->
  </div>
</template>

<script>
import { smsVerifyList , smsVerify , smsDetail , scenicPost } from '@/request/scenics.js'
import { Message } from 'element-ui'
export default {
  data() {
    return {
      verifyDialogVisible: false,
      imgXl: require("@/images/scenic/sj.png"),
      imgXlb: require("@/images/scenic/sjh.png"),
      tableData: [
      ],
      options: [
      ],
      value: "",
      value1: "",
      radio: "",
      form: {
        id:'',
        status:1,
        remark:'',
        token:window.sessionStorage.getItem('Token'),
      },
      data:{
        token:window.sessionStorage.getItem('Token'),
        start_time:'',
        end_time:'',
        ScenicID:'',
        page_size:10,
        page:1
      },
      total:0,
      flow:true,
      value1:'',
      str:{}
    };
  },
  created(){
    let data = {
      token:window.sessionStorage.getItem('Token'),
      page:1,
      page_size:999
    }
    scenicPost(data).then(res=>{
      if(res.data.status=='ok'){
        this.options = res.data.result.data
      }
    })
    this.getList()
  },
  methods: {
    chaxun(){
      if(this.value1){
        this.data.start_time = this.value1[0]
        this.data.end_time = this.value1[1]
      }else{
        this.data.start_time = ''
        this.data.end_time = ''
      }
      this.data.page = 1
      this.getList()
    },
    currenchange(e){
      this.data.page = e
      this.getList()
    },
    succesBtns(){
      smsVerify(this.form).then(res=>{
        if(res.data.status=='ok'){
          Message.success('操作成功')
          this.getList()
          this.verifyDialogVisible = false
        }else{
          Message.error(res.data.msg)
        }
      })
    },
    getList(){
      smsVerifyList(this.data).then(res=>{
        if(res.data.status=='ok'){
          this.tableData = res.data.result.data
          this.total = res.data.result.total
        }
      })
    },
    DetailverifyFn(row){
      let data = {
        token:window.sessionStorage.getItem('Token'),
        id:row.scenicpayid
      }
      smsDetail(data).then(res=>{
        if(res.data.status=='ok'){
          this.form = {
            id:row.scenicpayid,
            status:res.data.result.status,
            token:window.sessionStorage.getItem('Token'),
          }
          this.str = {
            remit_name:res.data.result.remit_name,
            remit_date:res.data.result.remit_date,
            remit_img:res.data.result.remit_img,
            remit_code:res.data.result.remit_code,
            jfy_amount:res.data.result.jfy_amount
          }
          this.verifyDialogVisible = true;
          this.flow = false
        }
      })
    },
    //审核
    verifyFn(row) {
      let data = {
        token:window.sessionStorage.getItem('Token'),
        id:row.scenicpayid
      }
      smsDetail(data).then(res=>{
        if(res.data.status=='ok'){
          this.form = {
            id:row.scenicpayid,
            status:res.data.result.status==3?res.data.result.status:1,
            token:window.sessionStorage.getItem('Token'),
          }
          this.str = {
            remit_name:res.data.result.remit_name,
            remit_date:res.data.result.remit_date,
            remit_img:res.data.result.remit_img,
            remit_code:res.data.result.remit_code,
            jfy_amount:res.data.result.jfy_amount
          }
        }
      })
      this.flow = true
      this.verifyDialogVisible = true;
    },
    // 弹框X
    verifyHandleClose() {
      this.verifyDialogVisible = false;
    },
    // 表头设置
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      return this.utils.tableHeaderColor({
        row,
        column,
        rowIndex,
        columnIndex
      });
    },
    cellStyle({ row, rowIndex }) {
      return this.utils.cellStyle({
        row,
        rowIndex
      });
    }
  }
};
</script>

<style lang="less" scoped>
.editForm {
  .itemBtnS {
      margin-top: 35px;
      display: flex;
      justify-content: center;
    /deep/.el-button {
      width: 100px;
      height: 40px;
      background: #d9d9d9;
      border-radius: 4px;
      font-family: ".PingFang SC";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      /* identical to box height */
      text-align: center;
      color: #ffffff;
      border: none;
    }
    .btnL {
      background: #246deb;
      border-radius: 4px;
      width: 100px;
      height: 40px;
    }
  }
  /dee/.el-input {
    width: 500px;
    height: 40px;
  }
}
.autorDialog {
  /deep/.el-dialog--center {
    text-align: center;
  }
  .autorYj {
    display: flex;
    justify-content: space-around;
    align-items: center;
    margin-top: 40px;
    .autorBtn {
      margin-top: 42px;
      .btnCan {
        width: 100px;
        height: 40px;
        background: #d9d9d9;
        border-radius: 4px;
        font-family: ".PingFang SC";
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        /* identical to box height */
        color: #ffffff;
      }
      .btnSure {
        width: 100px;
        height: 40px;
        background: #246deb;
        border-radius: 4px;
        font-family: ".PingFang SC";
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        /* identical to box height */
        color: #ffffff;
      }
    }
  }
}
.conentBox {
  // height: 80vh;
  margin-top: 17px;
  .conentRow {
    display: flex;
    flex-wrap: wrap;
    margin: 20px 0;
    // .conentCol {
    //   width: 240px;
    //   position: relative;
    //   /deep/.el-input {
    //     width: 100%;
    //   }
    // }
    .conentColSele {
      //   width: 260px;
      margin-right: 60px;
      position: relative;
      /deep/.el-select {
        width: 240px;
      }

      .imgPosi {
        position: absolute;
        top: 17px;
        right: 11px;
      }
    }
    /deep/.el-date-editor {
      width: 260px;
    }
    .conentBtn {
      // width: 120px;
      font-family: ".PingFang SC";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      line-height: 20px;
      /* identical to box height */

      color: #ffffff;
      /deep/.el-button {
        width: 100px;
        // width: 84%;
        background: #246deb;
        border-radius: 4px;
      }
    }
  }
}
.scenicBtn {
  // width: 596px;
  height: 40px;
  display: flex;
  justify-content: flex-end;

  .el-button {
    width: 120px;
    display: flex;
    justify-content: center;
    font-family: ".PingFang SC";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    // margin-right: -272px;
    // line-height: 20px;
    /* identical to box height */
    margin-right: -70px;
    color: #246deb;
    background: #ffffff;
    border: 1px solid #246deb;
    border-radius: 4px;
  }
}

// 分页
.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 32px;
  margin: 42px auto;
  span {
    font-family: ".PingFang SC";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    color: #000000;
  }
}

/deep/.el-pagination.is-background .el-pager li {
  margin: 0 5px;
  color: #000000;
  background: #ffffff;
  border: 1px solid #e5e5ea;
  border-radius: 2px;
  min-width: 32px;
}
/deep/.el-pager li {
  font-family: ".PingFang SC";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  padding: 0 4px;
  background: #fff;
  min-width: 32px;
  height: 32px;
  line-height: 32px;
  box-sizing: border-box;
}

/deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
  border: 1px solid #246deb;
  color: #246deb;
  background: white;
}

/deep/.el-pagination.is-background .btn-prev {
  color: #c0c4cc;
  height: 32px;
  min-width: 32px;
  background: white;
  border: 1px solid #e5e5ea;
}
/deep/.pagination .btn-prev .el-icon {
  display: block;
  font-size: 14px;
  font-weight: 700;
}

/deep/.el-pagination.is-background .btn-next {
  margin: 0 5px;
  background-color: white;
  color: #606266;
  min-width: 32px;
  height: 32px;
  border-radius: 2px;
  border: 1px solid #e5e5ea;
}

// 弹框
/deep/.el-dialog__header {
  height: 60px;
  line-height: 60px;
  padding: 0;
}

/deep/.el-dialog__body {
  height: ;
  padding: 0px 20px 20px;
}

// 弹框标题设置
/deep/.el-dialog__title {
  font-family: ".PingFang SC";
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  line-height: 28px;
  /* identical to box height */
  color: #000000;
}

/deep/.el-icon-close {
  font-family: ".PingFang SC";
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  line-height: 28px;
  /* identical to box height */
  color: #000000;
}

// 分割线
/deep/.el-divider--horizontal {
  display: block;
  height: 1px;
  width: 100%;
  margin: 0 0 20px 0;
}
/deep/.el-dialog__headerbtn {
  position: absolute;
  top: 0;
  right: 20px;
  padding: 0;
  background: 0 0;
  border: none;
  outline: 0;
  cursor: pointer;
  font-size: 16px;
}
</style>